import ReactMarkdown from "react-markdown";
import { Link, Text } from "@medentic/polaris-react";
interface TranslateLinkProps {
  text: string;
  onClick?(): void;
  disabled?: boolean;
  tone?: string;
}

type ToneValue = "base" | "subdued" | "disabled" | "critical" | "success";

export default function TranslateLink({
  text,
  onClick,
  disabled = false,
  tone = "subdued",
}: TranslateLinkProps) {
  return (
    <ReactMarkdown
      children={text}
      components={{
        a: ({ href, children }) => (
          <Link
            url={onClick ? undefined : href}
            onClick={onClick}
          >
            {children}
          </Link>
        ),
        p: ({ children }) => (
          <Text as="span" tone={disabled ? "disabled" : (tone as ToneValue)}>
            {children}
          </Text>
        ),
      }}
    />
  );
}
